import AppRoutes from './routes/AppRoutes'
import { AuthProvider } from '@/features/auth/hooks/useAuth'
import { LimiteDeErroGlobal } from '@/components/common/ErroNaTela'
import { AtualizadorDeTelas } from '@/features/aplicativo/AtualizadorDeTelas'
import { OfertaDeBiometria } from '@/features/auth/biometria/OfertaDeBiometria'
import { PushNoAplicativo } from '@/features/notificacoes/PushNoAplicativo'
import { FolhaDeContas } from '@/features/auth/contas/FolhaDeContas'
import { FolhaDeContasDoNavegador } from '@/features/auth/contas/FolhaDeContasDoNavegador'
import { AvisoDeAtualizacaoPronta } from '@/features/aplicativo/AvisoDeAtualizacaoPronta'
import { AvisoDeVersaoNova } from '@/features/aplicativo/AvisoDeVersaoNova'
import { TravaDoAplicativo } from '@/features/auth/biometria/TravaDoAplicativo'

/*
 * O limite de erro fica POR FORA do `AuthProvider`, e é de propósito: assim ele
 * alcança também uma falha do próprio provedor de autenticação. A tela de erro
 * não precisa do contexto — o token mora no `localStorage`, e o papel e a escola
 * quem informa é o backend, a partir do token. Cliente não é fonte de papel.
 */
function App() {
  return (
    <LimiteDeErroGlobal>
      <AuthProvider>
        {/* As telas novas do aplicativo (1.4): confirma que subiu e, fora da prova, baixa o pacote seguinte. */}
        <AtualizadorDeTelas />
        <AppRoutes />
        {/* 1.4: depois do login com senha, a pergunta da biometria (uma vez por conta, neste aparelho). */}
        <OfertaDeBiometria />
        {/* 1.4: o push — só pergunta se o servidor disser que está ligado (hoje, desligado). */}
        <PushNoAplicativo />
        {/* "Trocar de conta" (1.4): a folha de baixo, aberta pela gaveta e por Minha conta — `FolhaDeContas`. */}
        <FolhaDeContas />
        {/* E a do navegador (24/10/2026): as contas lembradas em cookie HttpOnly — `FolhaDeContasDoNavegador`. */}
        <FolhaDeContasDoNavegador />
        {/* 1.4: "Atualização pronta · Aplicar agora" — só a equipe, nunca com prova (`atualizacaoPronta.ts`). */}
        <AvisoDeAtualizacaoPronta />
        {/* No navegador: "Nova versão do portal · Atualizar" e a troca na próxima navegação — nunca na prova (`versaoNova.ts`). */}
        <AvisoDeVersaoNova />
        {/* 1.4: a trava ao abrir (opcional, Minha conta) — nunca durante uma prova. */}
        <TravaDoAplicativo />
      </AuthProvider>
    </LimiteDeErroGlobal>
  )
}

export default App
